import { Link } from "react-router-dom";
import { Camera, ShieldCheck, ExternalLink } from "lucide-react";
import { BACKEND, gbp } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const src = (u) => (u?.startsWith("/api/") ? `${BACKEND}${u}` : u);

export function PhotoVerifiedTag() {
  return <span className="chip bg-emerald-50 text-emerald-700 border border-emerald-200 text-[11px]" data-testid="photo-verified-tag"><Camera size={11} />Photo verified</span>;
}

export function ReviewPhotos({ photos, testid = "review-photos" }) {
  if (!photos?.length) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-3" data-testid={testid}>{photos.map((f, i) => (
      <a key={f.url} href={src(f.url)} target="_blank" rel="noreferrer" className="block w-20 h-20 rounded-lg overflow-hidden border border-slate-200 hover:opacity-90 transition-opacity" data-testid={`${testid}-${i}`}>
        <img src={src(f.url)} alt={f.name || "Review photo"} className="w-full h-full object-cover" loading="lazy" /></a>))}</div>
  );
}

export function JobPhotoPick({ options, picked, setPicked, max }) {
  if (!options?.length) return null;
  const toggle = (u) => setPicked(picked.includes(u) ? picked.filter((x) => x !== u) : picked.length < max ? [...picked, u] : picked);
  return (
    <div data-testid="review-job-photos"><div className="text-xs font-semibold text-slate-600 mb-1">Or pick photos from this job</div>
      <div className="flex flex-wrap gap-2">{options.map((f, i) => (
        <button type="button" key={f.url} onClick={() => toggle(f.url)} className={`w-16 h-16 rounded-lg overflow-hidden border-2 transition-colors ${picked.includes(f.url) ? "border-[#FF8166]" : "border-transparent opacity-80"}`} data-testid={`review-job-photo-${i}`}>
          <img src={src(f.url)} alt={f.name || "Job photo"} className="w-full h-full object-cover" /></button>))}</div></div>
  );
}

export function GuaranteeStrip() {
  const { settings } = useAuth();
  const g = settings?.guarantee;
  if (!g?.enabled) return null;
  return (
    <Link to="/guarantee" target="_blank" rel="noopener noreferrer" className="mt-3 flex items-center gap-2 rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-2 text-xs text-emerald-800 hover:bg-emerald-100 transition-colors" data-testid="guarantee-strip">
      <ShieldCheck size={16} className="text-emerald-600 shrink-0" />
      <span><b>Protected by the MyHomelyHub Guarantee</b> when you pay through MyHomelyHub, up to {gbp(g.max_amount)} if the work isn't right. <span className="inline-flex items-center gap-1 font-semibold underline underline-offset-2" data-testid="guarantee-strip-link">How the {gbp(g.max_amount)} guarantee works<ExternalLink size={12} /></span></span>
    </Link>
  );
}
